import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';

export const TagVariant = {
  DISPLAY: 'display',
  SELECTION: 'selection',
  ICON: 'icon',
} as const;

export type TagVariantType = (typeof TagVariant)[keyof typeof TagVariant];

export const TagColor = {
  GREEN: 'green',
  YELLOW: 'yellow',
  INDACO: 'indaco',
  VIOLET: 'violet',
  GREY: 'grey',
  SAND: 'sand',
} as const;

export type TagColorType = (typeof TagColor)[keyof typeof TagColor];

type TagBaseProps = {
  testId?: string;
  removeAriaLabel?: string;
};

export type DisplayTagProps = TagBaseProps & {
  variant?: typeof TagVariant.DISPLAY;
  color?: TagColorType;
  iconName?: TUNDR_ICONS;
};

export type SelectionTagProps = TagBaseProps & {
  variant: typeof TagVariant.SELECTION;
};

export type IconTagProps = TagBaseProps & {
  variant: typeof TagVariant.ICON;
  color?: TagColorType;
  iconName: TUNDR_ICONS;
};

export type TagProps = DisplayTagProps | SelectionTagProps | IconTagProps;
